
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ActionHandler } from '@app/core/components/actions/action.handler';
import { AnteriorAction } from './master-anterior-access-profile.action';
import { ProximoAction } from './master-proximo-access-profile.action';

@Injectable()
export class MasterAccessProfileActions {
    constructor(
        private actionHandler: ActionHandler,
        
            private anteriorAction: AnteriorAction
            ,
        
            private proximoAction: ProximoAction
            
        
    ) {}


    anterior(context): Observable<any> {
        return this.actionHandler.perform(this.anteriorAction, context);
    }

    proximo(context): Observable<any> {
        return this.actionHandler.perform(this.proximoAction, context);
    }


}